import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import './Year.scss'

const Line = (
  { start, end },  
) => (
  <svg>
    <line
      x1={0}
      y1={`${start}%`}
      x2="100%"
      y2={`${end}%`}
    />
  </svg>
)

export default class Year extends React.Component {
  static propTypes = {
    hasPrev: PropTypes.bool.isRequired,
    year: PropTypes.number.isRequired,
    applicantsCount: PropTypes.number.isRequired,
    acceptanceRate: PropTypes.number.isRequired,
    enrollmentRate: PropTypes.number.isRequired,
    maxApplicants: PropTypes.number.isRequired,
    prevApplicantsCount: PropTypes.number,
    prevAcceptanceRate: PropTypes.number,
    prevEnrollmentRate: PropTypes.number,
  }

  render() {
    const {
      year,
      maxApplicants,
      applicantsCount,
      acceptanceRate,
      enrollmentRate,
      hasPrev,
      prevApplicantsCount,
      prevAcceptanceRate,
      prevEnrollmentRate,
    } = this.props

    const getYearTotalPct = (applicants) => (applicants / maxApplicants) * 100
    const yearTotalPct = getYearTotalPct(applicantsCount)
    const prevYearTotalPct = hasPrev ? getYearTotalPct(prevApplicantsCount) : undefined

    const getY = (pct, yearTotalPct) => 100 - yearTotalPct + (yearTotalPct - yearTotalPct * (pct / 100))
    const triangleY = getY(acceptanceRate, yearTotalPct)
    const circleY = getY(enrollmentRate, yearTotalPct)

    const getPercentage = (value) => Math.round(value * 10) / 10

    return (
      <div className="year-comp">
        <div className="year-title">{year}</div>
        <div className="animated-chart-wrapper">
          <div
            className="bar-chart"
            title={`${applicantsCount} Applicants`}
            style={{ height: `${yearTotalPct}%` }}
          >
            <div
              className="shape-point"
              style={{ bottom: `${enrollmentRate}%` }}
            >
              <div title={`${enrollmentRate}% enrollment rate`}>
                <svg viewBox="0 0 23 23">
                  <circle
                    cx="11.5"
                    cy="11.9"
                    r="10"
                  />
                </svg>
              </div>
            </div>
            <div
              className="shape-point"
              style={{ bottom: `${acceptanceRate}%` }}
            >
              <div title={`${acceptanceRate}% acceptance rate`}>
                <svg viewBox="0 0 23 23">
                  <polygon points="11.5,2.7 17.1,12.3 22.6,21.9 11.5,21.9 0.4,21.9 5.9,12.3 	" />
                </svg>
              </div>
            </div>
          </div>
          {hasPrev && (
            <Fragment>
              <div className="line-connect triangular">
                <Line
                  start={getY(prevAcceptanceRate, prevYearTotalPct)}
                  end={triangleY}
                />
              </div>
              <div className="line-connect circular">
                <Line
                  start={getY(prevEnrollmentRate, prevYearTotalPct)}
                  end={circleY}
                />
              </div>
            </Fragment>
          )}
        </div>
        <ul className="label-column">
          <li className="data-row applicants">{applicantsCount}</li>
          <li className="data-row acceptance">{getPercentage(acceptanceRate)}%</li>
          <li className="data-row enrollment">{getPercentage(enrollmentRate)}%</li>
        </ul>
      </div>
    )
  }
}
